<template>
  <validation-provider
    v-slot="{ errors }"
    :name="fieldName"
    :rules="rules"
    :vid="vid"
  >
    <v-text-field
      :error-messages="errors"
      color="blue"
      :label="$t('fields.'+fieldName, fieldNameParams)"
      v-bind="$attrs"
      :type="type"
      :disabled="disabled"
      v-on="$listeners"
    />
  </validation-provider>
</template>

<script>
  export default {
    name: 'ValidatedTextField',

    props: {
      fieldName: String,
      rules: String,
      type: String,
      vid: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      fieldNameParams: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>
